import theme from '../Theme/Theme';

const styles = () => ({
  mapContainer: {
    height: '100%',
    width: '100%',
    zIndex: 1,
    [theme.screenSize.mobile]: {
      '&': {
        height: '100%',
        width: '100%',
      },
    },
  },
});

export default styles;
